import { getHubAuthHeaders } from "@helpers/lib/hub-auth";
import { fetch as expoFetch } from "expo/fetch";

import { pumpSSEStream } from "./parseUIMessageStream";

/**
 * POST JSON to a ProEthics endpoint with hub auth, drain the SSE response into `feed`.
 * `signal` cancels the trailing audio phase; safe at any point since the server
 * writes `mastra_messages` when the agent stream resolves, before TTS begins.
 */
export const streamProethicsPost = async (
	url: string,
	body: unknown,
	feed: (chunk: Uint8Array) => void,
	signal?: AbortSignal,
) => {
	const res = await expoFetch(url, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			...(await getHubAuthHeaders()),
		},
		body: JSON.stringify(body),
		signal,
	});
	await pumpSSEStream(res.body, feed);
};
